module.exports = __webpack_public_path__ + "static/media/howtobefat_img_1.a2524aa8.png";